import { useEffect, useRef, useState } from 'react';
import { Row, Col, Form, Button } from 'react-bootstrap';
import { Typeahead } from 'react-bootstrap-typeahead';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import { useDispatch, useSelector } from 'react-redux';
import { getFirstLoginStatus, loadCityNameDropdown, loadCountryNameDropdown, loadStateNameDropdown } from '../redux/action';

const Location = ({ countries, setCountries, cities, setCities, states, setStates, zipCodes, setZipCodes, zipInput, setZipInput, search, setSearch, searchState, setSearchState, viewResult,
    forthStep, setForthStep, setFifthStep
}) => {
    const dispatch = useDispatch();

    const { loginStatus } = useSelector(state => state.data);
    const { countryNameDropdown } = useSelector((state) => state.data);

    const { stateDropdownData } = useSelector((state) => state.data);
    const { cityDropdownData } = useSelector((state) => state.data);

    const [countryNames, setCountryNames] = useState([]);

    useEffect(() => {
        setCountryNames(countryNameDropdown);
    }, [countryNameDropdown])


    const handleRemove = (item, setList) => {
        setList((prev) => prev.filter((val) => val !== item));
    };

    const handleAdd = (value, setList, resetInput) => {
        if (value && value.trim()) {
            setList((prev) => (prev.includes(value.trim()) ? prev : [...prev, value.trim()]));
            resetInput('');
        }
    };

    const renderSelectedTags = (items, onRemove) => (
        <div className="type-head-selected-container mb-2">
            {items.map((item, index) => (
                <div key={index} className="type-head-selected-options">
                    <span className="cross-mark" onClick={() => onRemove(item)}>&times;</span>
                    <span>{typeof item === 'object' ? item.label : item}</span>
                </div>
            ))}
        </div>
    );

    const hasRun = useRef(false);
    useEffect(() => {
        if (hasRun.current) return;
        hasRun.current = true;
        dispatch(loadCountryNameDropdown(search))
        dispatch(loadStateNameDropdown("", null));
        dispatch(loadCityNameDropdown("", null));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // Handle country selection and pass IDs as a comma-separated string
    useEffect(() => {
        if (countries.length > 0) {
            const countryIds = countries.map(country => country.value).join(',');
            dispatch(loadStateNameDropdown(countryIds, null));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [countries]);

    // Handle state selection and pass IDs as a comma-separated string
    useEffect(() => {
        if (states.length > 0) {
            const stateIds = states.map(state => state.value).join(',');
            dispatch(loadCityNameDropdown(stateIds, null));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [states]);
    // Trigger city API call when selected states change

    useEffect(() => {
        if (search && search.length >= 3) {
            dispatch(loadCountryNameDropdown(search));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [search]);

    const clearGuideSesion = () => {
        dispatch(getFirstLoginStatus(false))
    }
    return (
        <div className="search-contact-filter-container-second-third-div mt-4">
            <div className="search-contact-filter-container-second-third-inner-div">
                <h6>🗺️ Location</h6>
            </div>

            <Form className="search-contact-form-container">
                <Row className="mb-3">
                    <Col md={viewResult ? 12 : 6}>
                        <Form.Group controlId="countryRegion" className={`${(loginStatus && forthStep) && 'guide4-focus-input'}`} style={{ textAlign: "left" }}>
                            <Form.Label className="pb-2 pt-2">Country / Region</Form.Label>
                            {renderSelectedTags(countries, (item) => handleRemove(item, setCountries))}
                            <Typeahead
                                flip={true}
                                id="country-typeahead"
                                className="w-100 "
                                options={countryNames
                                    .filter(opt => !countries.includes(opt))
                                }
                                labelKey="label"
                                placeholder="Search for country"
                                selected={[]}
                                onInputChange={(val) => {
                                    setSearch(val);
                                    if (val.trim() === '') {
                                        setSearch("");
                                    }
                                }}
                                onChange={(val) => {
                                    if (val.length > 0 && !countries.includes(val[0])) {
                                        const selectedCountry = val[0];
                                        setCountries([...countries, selectedCountry]);
                                        setCountryNames([]);
                                        setForthStep(false);
                                        setFifthStep(true);
                                    }
                                }}
                            />
                            <span ><em style={{ fontSize: "11px" }}>Note: Type ateast 3 letters to search country</em></span>

                            {loginStatus && forthStep && (
                                <div className="guide-tooltip step4-tooltip">

                                    <div className="guide-right-hand">
                                        👈
                                    </div>

                                    <div className="guide-badge">
                                        Step 4 of 6
                                    </div>

                                    <h6>Selecte the country</h6>

                                    <p>
                                        Type a country name such as <b>Unites Statea</b>, <b>United Kingdom</b>,
                                        or <b>Australia</b> and select from <b>Dropdown</b>.
                                    </p>

                                    <div className="guide-footer">
                                        <button
                                            className="guide-skip-btn"
                                            onClick={clearGuideSesion}
                                        >
                                            Skip Tour
                                        </button>

                                        <button
                                            className="guide-next-btn"

                                            onClick={() => {
                                                // if (jobTitles.length === 0 && !jobTitleInput){
                                                //     toast.warning("Type any job title");
                                                //     return;
                                                // }
                                                setForthStep(false);
                                                setFifthStep(true);
                                            }}
                                        >
                                            Next →
                                        </button>
                                    </div>
                                </div>
                            )}
                        </Form.Group>
                    </Col>

                    <Col md={viewResult ? 12 : 6}>
                        <Form.Group controlId="stateRegion">
                            <Form.Label className="pb-2 pt-2">State</Form.Label>
                            {renderSelectedTags(states, (item) => handleRemove(item, setStates))}
                            <Typeahead
                                flip={true}
                                id="state-typeahead"
                                onInputChange={(text) => setSearchState(text)}
                                onChange={(val) => {
                                    if (val.length > 0 && !states.includes(val[0])) {
                                        setStates([...states, val[0]]);
                                    }
                                }}
                                options={stateDropdownData
                                    .filter(opt => !states.includes(opt)) // filter full objects, not just strings
                                }
                                labelKey="label"
                                placeholder="Enter state name"
                                selected={[]}
                            />
                        </Form.Group>
                    </Col>
                </Row>

                <Row className="mb-3">
                    {/* City */}
                    <Col md={viewResult ? 12 : 6}>
                        <Form.Group controlId="cityInput">
                            <Form.Label className="pb-2 pt-2">City</Form.Label>
                            {renderSelectedTags(cities, (item) => handleRemove(item, setCities))}
                            <Typeahead
                                flip={true}
                                id="city-typeahead"
                                className="w-100"
                                options={cityDropdownData
                                    .filter(opt => !cities.includes(opt)) // filter full objects, not just strings
                                }
                                placeholder="Enter city"
                                selected={[]}
                                onInputChange={(text) => setSearchState(text)}
                                onChange={(val) => {
                                    if (val.length > 0 && !cities.includes(val[0])) {
                                        setCities([...cities, val[0]]);
                                    }
                                }}
                            />
                        </Form.Group>
                    </Col>

                    <Col md={viewResult ? 12 : 6}>
                        <Form.Group controlId="zipInput">
                            <Form.Label className="pb-2 pt-2">Postal / ZIP Code</Form.Label>
                            {renderSelectedTags(zipCodes, (item) => handleRemove(item, setZipCodes))}
                            <div className="d-flex align-items-center gap-2">
                                <Form.Control
                                    type="text"
                                    placeholder="Enter ZIP code"
                                    value={zipInput}
                                    maxLength={10}
                                    onChange={(e) => setZipInput(e.target.value)}
                                    // onChange={(e) => {
                                    //     const value = e.target.value.replace(/\D/g, ""); // Allow only numbers
                                    //     setZipInput(value);
                                    // }}
                                    onKeyDown={(e) => {
                                        if (e.key === "Enter") {
                                            e.preventDefault();
                                            handleAdd(zipInput, setZipCodes, setZipInput);
                                        }
                                    }}
                                />
                                <Button
                                    className="btn btn-primary search-view-result-btn"
                                    onClick={() => handleAdd(zipInput, setZipCodes, setZipInput)}
                                >
                                    {viewResult ? <i className="fa fa-plus"></i> : "Add"}
                                </Button>
                            </div>
                        </Form.Group>
                    </Col>
                </Row>
            </Form>
        </div>
    );
};

export default Location;
